const init = () => {

  if (document.querySelector(`[data-scroll-next-section]`)) {

    document.querySelector(`[data-scroll-next-section]`).addEventListener(`click`, e => {
      e.preventDefault()

      const scrollWrapper = (document.querySelector('[data-scroll-wrapper]')) ? document.querySelector('[data-scroll-wrapper]') : window

      scrollWrapper.scrollBy({
        left: 0,
        top: window.innerHeight,
        behavior: `smooth`
      })
    })

  }

}

export default {
  init
}
